  <template>
  <div class="animated fadeIn">
  <!-- <b-breadcrumb><strong>Fit Technician Log List</strong></b-breadcrumb>
  <b-button style="float:right;" variant="success" class="mt-2">Download</b-button>  -->
  <b-row class="design-container-details__main">
    <b-col md="12">
        <b-breadcrumb><strong>Fit Technician Log List</strong></b-breadcrumb>
        <b-button style="float:right;" variant="success" class="mt-2 mr-3" @click="getfFtlogDeatilsDownload();" download>Download</b-button> 
    </b-col>
  
  </b-row>
   
  <b-row >
       
    <!----- SideBar All Design List ---->
     <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
    <!----- SideBar All Design List End ----> 

     <div class="design-container-details__main">
      <div class="col-md-12 ">
        <!-- <b-button style="float:right;" variant="success" class="mt-2">Download</b-button>  -->

            <!-- code for table -->
              <b-row>
                
                <b-col md="12">
                  <b-card-body>
                  <div class="row mt-4"> 
                  </div> 

                  <div class="col-md-12">

                     <b-table class="" show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields1"  :current-page="currentPage" :perPage="perPage":bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                    
                    <template slot="sample_receiveddate" slot-scope="row">
                    <p v-if="row.item.sample_received_date == null">NA</p>
                    <p v-if="row.item.sample_received_date != null">{{row.item.sample_received_date}}</p>
                    </template>

                    <template slot="vendorname" slot-scope="row">
                      <p v-if="row.item.vendor_name == null">NA</p>
                       <p v-if="row.item.vendor_name != null">{{row.item.vendor_name}}</p>
                    </template>
                  

                    <!-- 
                    <template slot="actions" slot-scope="row">
                      <i @click="editinfoModal(row.item)"  data-toggle="tooltip" title="Update Vendor Details" class="fa fa-pencil-square-o" aria-hidden="true" style=" color: green;">&nbsp;&nbsp;&nbsp;&nbsp;
                    
                      </i>
                      <i  v-on:click="deleteinfoModal(row.item)"  data-toggle="tooltip" title="Delete Vendor Details"  class="fa fa-trash" aria-hidden="true" style="color: red">
                        
                      </i>

                    </template>   -->

                    <template slot="action" slot-scope="row">

                        <b-col md="12" class="pull-right text-right">
                         
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
                          <template v-slot:button-content>
                            <button @click="opendesignModal(row.item)" style="border: none;" class="btn btn-link"><span class="cui-options icons font-1xl d-block" style="font-size: 15px;"></span></button>
                          </template>
                          <b-dropdown-item 
                          
                          target="_blank" >
                        

                         <b-button type="submit" variant="primary" @click="editinfoModal(row.item)"><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Style Details</b-button>
                        
                  


                        </b-dropdown-item>

             
                        </b-dropdown>
 
                        </b-col>
                    </template>        
                  </b-table> 
                </div>
                    <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>  
            <!-- Info modal -->         
                 <!-- </div> -->

                  </b-card-body>
               </b-col>
            </b-row>          
             <!-- code for table ends -->

 
      </div>
    </div>     
      
  </b-row>    



      <b-modal title="Update Password" v-model="fittech_log_model" @ok="fittech_log_model = false" size="lg">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Fit-Tech Log Details</h5>
          <b-form-group style="float:right;">
            <!-- <b-button @click="editcancel()"><i class="fa fa-times"></i></b-button> -->
          </b-form-group> 
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
              <b-row >
                  <b-col md="6">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Sample Type </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.sample_type != null">{{selected_fittech_data.sample_type}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.sample_type == null || selected_fittech_data.sample_type == ''">
                        NA
                      </b-col>
                       
                      <!-- <b-col md="12" class="pull-right titleb">{{style_details.sample_type}}
                      </b-col> -->
                    </b-form-group>
                  </b-col>
                 
                  <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Style Code </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.style_code != null">{{selected_fittech_data.style_code}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.style_code == null || selected_fittech_data.style_code == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <b-col md="5" class="pull-left">
                        <label for="name"><b>Sample Received Date</b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.sample_received_date != null">{{selected_fittech_data.sample_received_date}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.sample_received_date == null || selected_fittech_data.sample_received_date == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Vendor Name </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.vendor_name != null">{{selected_fittech_data.vendor_name}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.vendor_name == null || selected_fittech_data.vendor_name == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                   <!-- <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Product Type </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.product_type != null">{{selected_fittech_data.product_type}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.product_type == null || selected_fittech_data.product_type == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col> -->
                   <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Sample Size </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.requested_size != null">{{selected_fittech_data.requested_size}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.requested_size == null || selected_fittech_data.requested_size == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Color </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.color != null">{{selected_fittech_data.color}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.color == null || selected_fittech_data.color == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  
                  <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>No. of PCS. Received </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.no_of_pcs_received != null">{{selected_fittech_data.no_of_pcs_received}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.no_of_pcs_received == null || selected_fittech_data.no_of_pcs_received == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  
                  <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Handed Over For FIT/PP </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.handed_pp != null">{{selected_fittech_data.handed_pp}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.handed_pp == null || selected_fittech_data.handed_pp == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  
                  <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Comment's Received  </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.comments != null">{{selected_fittech_data.comments}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.comments == null || selected_fittech_data.comments == ''">
                        NA
                      </b-col>
                   </b-form-group>
                   </b-col>

                    <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Courier Date</b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.due_date != null">{{selected_fittech_data.due_date}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.due_date == null || selected_fittech_data.due_date == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  
                  <b-col md="6">
                    <b-form-group>
                       <b-col md="5" class="pull-left">
                        <label for="name"><b>Lead Time  </b></label>
                      </b-col> 
                      <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.lead_time != null">{{selected_fittech_data.lead_time}}
                      </b-col>
                      <b-col md="6" class="pull-right titleb" v-if="selected_fittech_data.lead_time == null || selected_fittech_data.lead_time == ''">
                        NA
                      </b-col>
                   </b-form-group>
                  </b-col>
                  
                  
              </b-row>
             <hr>
                
                <div slot="footer" class="text-right mt-2">
                  <!-- <b-button type="submit" class="mr-4" variant="success" ></b-button> -->
                  <b-button variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 



    
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'



import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data () {
    return {
      isBusy: false,  
      sampelAddModal: false,    
      customer: {},
      addAgentMaster : false,
      editAgentMaster:false,
      bordered: true,
      showSideMenu:true,
      items:[],
      result:[],
      value:[],
      sortDesc: true,
      sortDirection: 'desc',
      fields1: [
          { key: 'style_code', label: 'Style Code', sortDirection: 'desc' },
        { key: 'sample_type', label: 'Sample Type' },
           { key: 'sample_receiveddate', label: 'Sample received date'},
            { key: 'vendorname', label: 'Vendor Name'},
            // { key: 'operational_status', label: 'Product Type'},
        { key: 'requested_size', label: 'Sample Size' },
        { key: 'color', label: 'Color'},
          { key: 'action', label: 'Action' ,tdClass: 'nameOfTheClass'},
         
      
       ],
       fittech_log_model: false,
       showdesigndetails: false,
       currentPage: 1,
       perPage:  10,
       sortBy: null,
       sortDesc: true,
       sortDirection: 'desc',
       filter: null,
       totalRows: 0,
       selected_style_id: 0,
       style_details: [],
       img_path: '',
       status: '',
       comment: '',
       selected: '',
       style_name_arr: [],
       brand_title_arr: [],
       segment_title_arr: [],
       collection_title_arr: [],
       brand_title: '',
       showfeedbackmodel: false,
       feedback: '',
       route_id: 0,
       search_item: '',
       sub_cat_id_arr: [],
       selected: '',
       search_subcat: 0,
       search_utility: 0,
      search_po: 0,
      selected_fittech_data:{},
   }

  },
  created: function() { 
  
    this.getfittechnicianstylelist(); 
    // this.getfittechdatalist();
   //this.getdesigndetail();
  },
 computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields1
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },

  
  methods: 
  {  
    closefeedback: function(){
      this.showfeedbackmodel = !this.showfeedbackmodel;
    },
            // Function For Action on status
    updatestylestatus: function(comment,value) {
      document.getElementById("overlay").style.display = "block";
      var status = value;
      var comment = comment;
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 
             
      const Obj={
        operational_status: status,
        updated_by: userInfo[0].email_id,
        user_id: userInfo[0].user_id,
        style_id: this.selected_style_id,
        comments : comment
      } 
      axios.post(`${CONSTANTS.API_URL}/updatestylestatus`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data
        if (this.result.returnmsg === 'Successful') {
          // alert("Status Updated Successfully");
           this.$fire({
                 text:"Status Updated Successfully",
                 type: "success",
                 timer: 30000
                        })
          this.showdesigndetails = !this.showdesigndetails;
          this.getdesignheadstyledetails(); 
        }else {
         // alert("Please Check Status");
          this.$fire({
                 text:"Please Check Status",
                 type: "warning",
                 timer: 30000
                        })
          
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

    commentcancel: function(){
      
      this.showdesigndetails = !this.showdesigndetails;
      // this.isBusy = !this.isBusy;
    },


    editinfoModal: function (value) {

      this.selected_fittech_data= value;
      this.fittech_log_model = !this.fittech_log_model;
        
      },


        
           /****** Function to design details ********/
       getdesigndetail: function () {
         document.getElementById("overlay").style.display = "block";
   
           this.isBusy = true;
       
           const Obj = {
                style_id: this.selected_style_id 
                             
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.img_path = this.style_details.style_image;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;                
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },

    onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },


      opendesignModal(value) {
        this.route_id=value.style_id;
        
      },

    editcancel: function() {
      this.customer = {};
      this.fittech_log_model = !this.fittech_log_model;
        },

    getfittechnicianstylelist: function(value) 
    {
      this.isBusy = !this.isBusy;
      // document.getElementById("overlay").style.display = "none";
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 

      const Obj = {
        fittech_id: user_id,
        }
      
        axios.post(`${CONSTANTS.API_URL}/getfittechdatalist`,Obj)
        .then(response => {
       
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 
            // this.operational_status = this.items.operational_status;
            
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      
    },

    getfittechdatalist: function ()
    {
      document.getElementById("overlay").style.display = "block";
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 

      const Obj = {
        fittech_id: user_id,
        }
            
        axios.post(`${CONSTANTS.API_URL}/getfittechdatalist`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {
            
          this.style_details  = this.result.returnvalue;
                         
          }else {
            this.style_details =[];
            
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    getfFtlogDeatilsDownload: function ()
    {

      document.getElementById("overlay").style.display = "block";
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 

      const Obj = {
        fittech_id: user_id,
        }

          axios.post(`${CONSTANTS.API_URL}/fitlogdatadownload`, Obj)
          .then(response => {

            console.log(response.data);
            this.downloadHelper(response.data);
              

        })


      },

      downloadHelper(csv) {

      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = "FitLog_Details.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
            
    },

  }
}
</script>
<style>
.account-settings__content>* {
    flex-grow: 1;
}

.profile-settings {
    flex-grow: 1;
    padding: 20px 24px;
}

.profile-settings>h1 {
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.profile-settings .content {
    display: flex;
}
.profile-settings .content .profile-fields-container {
    max-width: 356px;
    margin-right: 56px;
}
.profile-settings .tabular-fields {
    font-size: 14px;
    line-height: 20px;
    flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
    margin-top: 20px;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.profile-settings .tabular-fields .field-row>.field-label {
    color: var(--fill-grey-medium);
    min-width: 100px;
    margin: 12px 0;
}
.profile-settings .tabular-fields .field-row>.field-value {
    margin-left: 32px;
    flex-grow: 1;
}

.design-container-details__main{
 
  background-color:white;
  border-left:1px solid #d4d4d4;

}

.profile-settings .content .img.img-invalid {
    background-color: #6f4ce6;
}
.profile-settings .content .img {
    max-width: 100%;
    position: relative;
    height: 175px;
    width: 175px;
    border-radius: 4px;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border: 1px solid var(--fill-grey-light2);
    padding: 5px;
}


</style>


